export default "__VITE_ASSET__BwsNbPen__"